import { render, staticRenderFns } from "./orderAdd.vue?vue&type=template&id=56c887a1&scoped=true&"
import script from "./orderAdd.vue?vue&type=script&lang=js&"
export * from "./orderAdd.vue?vue&type=script&lang=js&"
import style0 from "./orderAdd.vue?vue&type=style&index=0&id=56c887a1&lang=less&scoped=true&"
import style1 from "./orderAdd.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c887a1",
  null
  
)

export default component.exports